import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { logOut } from '../login/action';
import * as QueryParams from 'query-string';
import { callApi, Method, request } from '../../api/Api';
import { getConfig } from '../../services/environment';
import { stopLoading, showErrorMessage, startLoading } from '../layout/action';
import { GET_DRIVER_VIEWORDER_STATES, setDriverViewOrderStates } from './action';


export function* callGetDriverViewOrderStates(action) {
   
  try {
     const { loginState } = yield select();
     const { userContext } = loginState;
     yield put(startLoading())
     const stateResponse = yield call(callApi, {
        method: "GET",
        url: `/eua/${action.payload}/order`
     })
     
     const { data } = stateResponse;
     yield put(setDriverViewOrderStates(data))
     yield put(stopLoading())
  } catch (err) {
     yield put(stopLoading())
     yield put(showErrorMessage({ error: err, title: "Get view order list" }))
  }
}

export function* watchGetDriverViewOrderStates() {
  yield takeEvery(GET_DRIVER_VIEWORDER_STATES, callGetDriverViewOrderStates);
}